import { gql, useMutation } from '@apollo/client'
import { useAlert, useNotification } from '@btime/react-messager'
import { useTranslation } from 'react-i18next'

import { triggersClient } from '../../../../utils/apollo/api'

const MUTATION = gql`
  mutation RemoveTriggers($ids: [Int]) {
    removeTriggers(ids: $ids)
  }
`

export const useRemoveRoutines = () => {
  const [request, state] = useMutation(MUTATION, { refetchQueries: ['Triggers'], client: triggersClient })
  const notify = useNotification()
  const modal = useAlert()
  const { t } = useTranslation('common')

  const handleRequest = item => {
    if (!modal.confirm({ title: t('routines.confirmRemove', { name: item.name }) })) return false

    return request({ variables: { ids: [item.id] } }).then(resp => {
      if (!!resp.errors) notify.error({ title: t('routines.removeError') })
    })
  }

  return [handleRequest, state]
}
